const allowedUrls = [
  "https://docs.google.com/document",
  "https://*.sharepoint.com/", // This will match any SharePoint domain
  "https://*//:*.sharepoint.com/_layouts/", // For SharePoint specific paths
  "https://*//:*.sharepoint.com/sites/", // For SharePoint sites
];

export default allowedUrls;
